import Vue from 'vue'
import Vuex from 'vuex'
import collection from './collection'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export function makeStore (states) {
  collection.state = states;
  return new Vuex.Store({
    modules: {
      front: collection
    },
    strict: debug
  })
}